import type { FlowState } from "../flow/machine";
import type { InstallRunner } from "../flow/runner";
import { t } from "../i18n";
import { ForwardingTable } from "./GroupWidgets";
import { EsimNote } from "./SimChecklist";

export function LiveStep({ runner, s }: { runner: InstallRunner; s: FlowState }) {
  const caps = s.enrollment?.capabilities;
  if (s.mode === "stock") {
    return (
      <div class="panel">
        <h2 tabIndex={-1}>{t("live.stock_heading")}</h2>
        <p class="notice ok" role="status">{t("live.stock_intro")}</p>
        {s.leaveUnlocked && <p>{t("live.stock_unlocked")}</p>}
        <EsimNote where="stock" />
        <button type="button" class="primary" onClick={() => runner.restartWithAnotherPhone()}>{t("live.another")}</button>
      </div>
    );
  }
  const yes = (v: boolean | undefined) => (v === undefined ? "?" : v ? "✓" : "✗");
  const members = s.member?.members ?? [];
  const total = members.length || s.group?.memberCount || 0;
  return (
    <div class="panel">
      <h2 tabIndex={-1}>{t("live.heading", { group: s.group?.name ?? "", position: s.position ?? 0, total })}</h2>
      <p class="notice ok" role="status">{t("live.intro")}</p>
      {s.enrollment?.deviceId && <p class="muted">{t("live.device", { id: s.enrollment.deviceId })}</p>}
      {s.hopTest && <p class="muted">{s.hopTest.passed ? t("live.hop_test_passed") : t("live.hop_test_skipped")}</p>}
      {s.member && members.length > 0 && (
        <section aria-labelledby="live-fwd-h">
          <h3 id="live-fwd-h">{t("live.forwarding_heading")}</h3>
          <ForwardingTable members={members} positions={[s.member.position]} />
        </section>
      )}
      {caps && (
        <section class="caps" aria-labelledby="caps-h">
          <h3 id="caps-h">{t("live.caps.heading")}</h3>
          <ul>
            <li>{yes(caps.capture_downlink)} {t("live.caps.capture_downlink")}</li>
            <li>{yes(caps.capture_uplink)} {t("live.caps.capture_uplink")}</li>
            <li>{yes(caps.uplink_injection)} {t("live.caps.uplink_injection")}</li>
            <li>{yes(caps.call_screening_mode)} {t("live.caps.call_screening_mode")}</li>
            <li>{yes(caps.hold_supported)} {t("live.caps.hold_supported")}</li>
            <li>{yes(caps.call_waiting_delivered)} {t("live.caps.call_waiting_delivered")}</li>
            <li>{caps.forwarding_api ?? "?"} {t("live.caps.forwarding_api")}</li>
          </ul>
          {!caps.uplink_injection && <p class="notice warn">{t("live.recording_only")}</p>}
        </section>
      )}
      <button type="button" class="primary" onClick={() => runner.restartWithAnotherPhone()}>{t("live.another")}</button>
    </div>
  );
}
